module.exports = __webpack_public_path__ + "static/media/The return capture.f1a32586.PNG";